module.exports = __webpack_public_path__ + "static/lin-e53ac08733351d1cf1124fbac5489f07.png";